import { Component, input, output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import {
  ErrorRequiredComponent,
  shouldDisplayRequiredError,
} from '../../ui/errors/error-required/error-required';
import { IconField } from 'primeng/iconfield';
import { InputIcon } from 'primeng/inputicon';
import { InputText } from 'primeng/inputtext';
import { AutoFocus } from 'primeng/autofocus';
import { ErrorEmailComponent } from '../../ui/errors/error-email/error-email';
import { Mail01 } from '../../icons/mail-01/mail-01';
import { fieldControlId } from '../../ui/field/field-control-id';
// import { EnvelopeIconComponent } from '../../icons/envelope-icon/envelope-icon.component';

@Component({
  standalone: true,
  selector: 'app-email-input',
  imports: [
    IconField,
    InputIcon,
    InputText,
    ReactiveFormsModule,
    AutoFocus,
    ErrorEmailComponent,
    ErrorRequiredComponent,
    Mail01,
    // EnvelopeIconComponent,
  ],
  templateUrl: './email-input.html',
  styleUrl: './email-input.scss',
})
export class EmailInputComponent {
  formCtrl = input.required<FormControl>();
  ctrlPlaceholder = input<string>('');
  isDisabled = input<boolean>(false);
  hideErrors = input<boolean>(false);
  emailExists = input<boolean>(false);
  showIcon = input<boolean>(true);
  formCtrlId = input<string>();

  protected readonly inputId = fieldControlId(this.formCtrlId);
  formCtrlType = input<string>('email');
  shouldFocus = input<boolean>(false);

  onEnterClicked = output<void>();
  keyReleased = output<boolean>();
  inputLeft = output<string | number>();

  emailExistsErrorMessage = 'Korisnik sa ovom adresom već postoji u sistemu';

  handleKeyUp(value: any) {
    this.keyReleased.emit(value);
    if (value.keyCode === 13) {
      this.onEnterClicked.emit();
    }
  }

  handleBlur(event: any) {
    this.inputLeft.emit(event.target.value);
  }

  protected readonly shouldDisplayRequiredError = shouldDisplayRequiredError;
}
